module.exports = __webpack_public_path__ + "media/assets/images/firefox-9584dc7768bc66de270e486ee3ccc31d.png";